import { combineReducers } from 'redux'
import { reducer as toastrReducer } from 'react-redux-toastr'
import assets from './assets'
import user from './user'
import company from './company' //added
import loader from './loader'
import partnerList from './partnerList'
import notification from './notification'

// const reducers = {
//  // ... other reducers ...
//  toastr: toastrReducer // <- Mounted at toastr.
// }
// const reducer = combineReducers(reducers)
// const store = createStore(reducer)

export default combineReducers({
	assets: assets,
	user,
	company,
	partnerList,
	toastr: toastrReducer,
	notification,
	loader,
});
